// extracted by css-extract-rspack-plugin
export default {"messagesContainer":"IUlcJ","inputContainer":"ddGDQ"};